import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductMonitoreComponent } from './product-monitore.component';



@NgModule({
  declarations: [ProductMonitoreComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ProductMonitoreComponent
  ]
})
export class ProductMonitoreModule { }
